import React from "react";

export default function BoxedLayout(props){
    return (
        <div className="flex w-full justify-center">
            <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <div className="prose prose-lg max-w-none">
                    {props.content}        
                </div>
            </div>      
        </div>
    );
}